import React from 'react';
import classNames from 'classnames';
import { Icon, IconProp } from '@benzinga/core-ui';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faThreads } from '@fortawesome/free-brands-svg-icons/faThreads';
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faRss } from '@fortawesome/pro-regular-svg-icons/faRss';
import {
  authorFacebookHref,
  authorInstagramHref,
  authorLinkedinHref,
  authorThreadsHref,
  authorTiktokHref,
  authorTwitterHref,
} from '../utils/authorSocialHref';
import styles from './AuthorSocialMedia.module.scss';

/** Matches editorial-tools GET /api/v2/author* social_* fields + rss (synthetic Benzinga feed) */
export interface AuthorSocialMediaLinksI {
  uid: string | number;
  facebook?: string | null;
  instagram?: string | null;
  linkedin?: string | null;
  threads?: string | null;
  tiktok?: string | null;
  twitter?: string | null;
}

export interface AuthorSocialI {
  social: AuthorSocialMediaLinksI;
}

export interface AuthorSocialMediaI {
  name: string;
  url: string | undefined | null;
  icon: IconProp;
}

const AuthorSocialMedia: React.FC<AuthorSocialI> = props => {
  const { facebook, instagram, linkedin, threads, tiktok, twitter, uid } = props.social;

  const socialMedia: AuthorSocialMediaI[] = [
    { icon: faRss, name: 'rss', url: `https://www.benzinga.com/author/${uid}/rss.xml` },
    { icon: faFacebook, name: 'facebook', url: authorFacebookHref(facebook ?? null) },
    { icon: faInstagram, name: 'instagram', url: authorInstagramHref(instagram ?? null) },
    { icon: faLinkedin, name: 'linkedin', url: authorLinkedinHref(linkedin ?? null) },
    { icon: faThreads, name: 'threads', url: authorThreadsHref(threads ?? null) },
    { icon: faTiktok, name: 'tiktok', url: authorTiktokHref(tiktok ?? null) },
    { icon: faXTwitter, name: 'twitter', url: authorTwitterHref(twitter ?? null) },
  ];

  return (
    <div className={classNames(styles.wrapper, 'flex items-center gap-3')}>
      {socialMedia
        .filter(item => item.url)
        .map((social, i) => {
          return (
            <div className="inline-flex items-center justify-center" key={`${social.name}-${i}-${uid}`}>
              <a
                className={`icon rounded icon-${social.name.toLowerCase()}`}
                href={social.url ?? '#'}
                rel="noreferrer"
                target="_blank"
                title={social.name}
              >
                <Icon icon={social.icon} />
              </a>
            </div>
          );
        })}
    </div>
  );
};
export { AuthorSocialMedia };
